import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { CurrentIcon } from '@/components/icons/CurrentIcon';
import { HistoryIcon } from '@/components/icons/HistoryIcon';
import { cn } from '@/utils/cn';

export const PickemBetTabsCommon = ({
  list,
  history,
}: {
  list: React.ReactNode;
  history: React.ReactNode;
}) => {
  return (
    <TabGroup>
      <TabList className="mb-6 flex">
        <Tab className={({ selected }) => getTabClasses(selected)}>
          <CurrentIcon className="size-6 text-light-blue" />
          Current
        </Tab>
        <Tab className={({ selected }) => getTabClasses(selected)}>
          <HistoryIcon className="size-6 text-light-blue" />
          Picks History
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>{list}</TabPanel>
        <TabPanel>
          <div className="rounded-lg bg-dark-gray p-4">{history}</div>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
};

function getTabClasses(selected: boolean): string {
  return cn(
    'flex flex-1 flex-col items-center gap-2 rounded-lg border border-transparent px-4 py-2 transition-all',
    selected && 'border border-light-blue text-gray'
  );
}
